<script>
  import { presetDefaultMobile, presetDefaultDesktop, foregroundPosition, startingDay, selectedBackground, showCalendar, gradientEffect, retinaOutput, width, height, presets, selectedLayout, layouts, showCockerel } from '../stores.js';
  import { backgrounds } from '../data/backgrounds.js';
  import { days } from '../date.utils.js';

  export let svelteCanvas;

  const positions = [
    'Bottom-left',
    'Bottom-right',
    'Top-right',
    'Top-left'
  ];

  const gradientEffects = [
    'Overlay',
    'Subtle',
    'None'
  ];

  function changePosition(event) {
    foregroundPosition.update(position => parseInt(event.target.value, 10));
  }

  function changeDay(event) {
    startingDay.update(day => parseInt(event.target.value, 10));
  }

  function changeBackground(event) {
    selectedBackground.update(background => parseInt(event.target.value, 10))
  }

  function toggleCalendar(event) {
    // toggle the boolean
    showCalendar.update(show => !show);
    // // set background effect to none
    // if ($showCalendar === false) {
    //   gradientEffect.update(effect => 2);
    // }
  }

  function toggleCockerel(event) {
    // toggle the boolean
    showCockerel.update(show => !show);
  }

  function changeGradientEffect(event) {
    gradientEffect.update(effect => parseInt(event.target.value, 10));
  }

  // function toggleRetina(event) {
  //   retinaOutput.update(retina => !retina);
  //   if ($retinaOutput) {
  //     // width, height
  //     width.update(val => $width * 2);
  //     height.update(val => $height * 2);
  //   } else {
  //     width.update(val => $width / 2);
  //     height.update(val => $height / 2);
  //   }
  // }

  function updateWidth(event) {
    width.update(val => parseInt(event.target.value, 10));
    svelteCanvas.redraw();
  }
  function updateHeight(event) {
    height.update(val => parseInt(event.target.value, 10));
    svelteCanvas.redraw();
  }

  function setPresetDimensions(event) {
    const dimensions = presets[parseInt(event.target.value, 10)];
    width.update(val => dimensions[0]);
    height.update(val => dimensions[1]);
    svelteCanvas.redraw();
  }

  function changeLayout(event) {
    selectedLayout.update(position => parseInt(event.target.value, 10));
  }


  selectedLayout.subscribe(layout => {
    let dimensions = [0, 0];
    // for mobile layout, use the gradient for bottom- positions
    if (layout === 0 || layout === 1 || layout === 2) {
      foregroundPosition.update(() => 0);
      gradientEffect.update(() => 0);
      dimensions = presets[presetDefaultMobile];
    }
    // Desktop setup
    if (layout === 3) {
      dimensions = presets[presetDefaultDesktop];
    }
    width.update(val => dimensions[0]);
    height.update(val => dimensions[1]);
    if (svelteCanvas) {
      svelteCanvas.redraw();
    }
  });


</script>


<h2>Settings</h2>

<h3>Design</h3>
<!-- Layout -->
<div class="form-item">
  <fieldset>
    <legend>Layout</legend>
    {#each layouts as layout, i}
      <div>
        <input on:input={changeLayout} id={layout.toLowerCase()} value={i} name="design_layout" type="radio" checked={i === $selectedLayout}>
        <label for={layout.toLowerCase()}>{layout}</label>
      </div>
    {/each}
  </fieldset>
</div>


<h3>Dimensions</h3>
<div class="form-item dimensions">
  <div>
    <label for="width">Width</label>
    <input id="width" on:change={updateWidth} type="number" value={$width}>
  </div>
  <div>
    <label for="height">Height</label>
    <input id="height" on:change={updateHeight} type="number" value={$height}>
  </div>
</div>
<div class="form-item">
  <label for="dimensions-presets">Presets</label>
  <select id="dimensions-presets" name="dimensions_presets" on:change={setPresetDimensions}>
    {#each presets as preset, i}
      <option value={i}>{preset[0]} x {preset[1]}</option>
    {/each}
  </select>
</div>


<h3>Background</h3>
<!-- Background Image -->
<div class="form-item">
  <label for="background-image">Background Image</label>
  <select on:change{changeBackground} bind:value={$selectedBackground} name="background_image" id="background-image">
    {#each backgrounds as background, i}
      <option selected={i === $selectedBackground} value={i}>{background.name}</option>
    {/each}
  </select>
</div>
<!-- Gradient effect -->
<div class="form-item">
  <fieldset>
    <legend>Gradient Effect</legend>
    {#each gradientEffects as gradient, i}
      <div>
        <input on:input={changeGradientEffect} type="radio" name="gradient_effect" value={i} id={gradient.toLowerCase()} checked={i === $gradientEffect}>
        <label for={gradient.toLowerCase()}>{gradient}</label>
      </div>
    {/each}
  </fieldset>
</div>



<h3>Foreground</h3>

<!-- Show calendar -->
<div class="form-item">
  <!-- <input on:change={toggleCalendar} id="show-calendar" name="show_calendar" type="checkbox" checked={$showCalendar}> -->
  <input checked={$showCockerel} id="show-cockerel" name="show_cockerel" on:change={toggleCockerel} type="checkbox">
  <label for="show-cockerel">Show cockerel</label>
</div>
<!-- Show calendar -->
<div class="form-item">
  <input on:change={toggleCalendar} id="show-calendar" name="show_calendar" type="checkbox" checked={$showCalendar}>
  <label for="show-calendar">Show calendar</label>
</div>
<!-- Foreground position -->
<div class="form-item">
  <fieldset>
    <legend>Position</legend>
    {#each positions as position, i}
      <div>
        <input on:input={changePosition} id={position.toLowerCase()} value={i} name="foreground_position" type="radio" checked={i === $foregroundPosition}>
        <label for={position.toLowerCase()}>{position}</label>
      </div>
    {/each}
  </fieldset>
</div>



<h3 class:inactive={!$showCalendar}>Calendar Options</h3>

<!-- Starting day of Week -->
<div class="form-item" class:inactive={!$showCalendar}>
  <label for="starting-day">Week Starts On</label>
  <select on:change={changeDay} value={$startingDay} name="starting_day" id="starting-day">
    {#each days as day, i}
      <option value={i}>{day[1]}</option>
    {/each}
  </select>
</div>


<style>
  input[type="checkbox"] + label {
    display: inline-block;
  }
  .inactive {
    opacity: 0.3;
    pointer-events: none;
  }
  input[type="number"] {
    border-radius: 2px;
    display: block;
    font-family: inherit;
    padding: .5em;
  }
  .form-item.dimensions {
    display: flex;
    gap: .5em;
  }
  .dimensions input[type="number"] {
    max-width: 10ch;
  }
  h3 {
    border-top: 1px solid #ddd;
    margin: 0.9em 0 .3em;
    padding-top: 0.5em;
  }
</style>
